import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmMerge from './ConfirmMerge';
import EmailService from '../../../../services/EmailService';
import { EmailStore } from '../../../../state/EmailStore';
import { NavButtons } from '../NavButtons/NavButtons';
import TopicTracker from '../../../../tracking/TopicTracker';

export const ConfirmMergeContainer = ({
  isCancelEnabled,
  onConfirmButtonClick,
  onError,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [mergeCheckBox, setMergeCheckBox] = useState(false);

  useEffect(() => {
    TopicTracker.show('email', 'confirm-merge', { merge_status: EmailStore.getLoyaltyMergeStatus() });
  }, []);

  const toggleMergeCheckBox = () => setMergeCheckBox(!mergeCheckBox);

  const handleConfirmButtonClick = () => {
    TopicTracker.click('email', 'confirm-merge-ok', { merge_status: EmailStore.getLoyaltyMergeStatus() });

    if (EmailStore.isBothLoyaltyAccounts()) {
      onConfirmButtonClick();
    } else {
      setIsLoading(true);
      EmailService.merge(EmailStore.getMergeableEmail(), EmailStore.getLoyaltyMergeStatus())
        .then(() => {
          setIsLoading(false);
          onConfirmButtonClick();
        })
        .catch((error) => {
          setIsLoading(false);
          onError(error.message);
        });
    }
  };

  const handleCancelClickButton = () => {
    TopicTracker.click('email', 'confirm-merge-cancel', { merge_status: EmailStore.getLoyaltyMergeStatus() });
  };

  return (
    <Fragment>
      <ConfirmMerge
        isLoading={isLoading}
        onCheckBoxClick={toggleMergeCheckBox}
      />
      <NavButtons
        isCancelEnabled={isCancelEnabled}
        isLoading={isLoading}
        onClick={handleConfirmButtonClick}
        onClickCancel={handleCancelClickButton}
        isDisabled={!mergeCheckBox || isLoading}
      />
    </Fragment>
  );
};

ConfirmMergeContainer.propTypes = {
  isCancelEnabled: PropTypes.bool.isRequired,
  onConfirmButtonClick: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};
